export const BYTES_IN_MB = 1048576;

export const SECOND_MS = 1000;

export const MINUTE_MS = SECOND_MS * 60;

export const SERVICE_MOCK_DELAY = 750;

export const GOOGLE_RECAPTCHA_KEY = '6LeupZAUAAAAAHiq6_yclqXaE34LE_CnR0r5Jbo4';

export const ANIMATION_DEFAULT_DURATION = 400;

export const DONE_TIMEOUT_DURATION = 600;

export const DASHBOARD_PAGE_DATA_UPDATE_INTERVAL = MINUTE_MS * 1;

export const INFO_DOMAIN = 'agmsoft.info';

export const INFO_SITE_URL = `https://${INFO_DOMAIN}`;

export const EMPLOYEE_INFO_SITE_URL = `https://s.${INFO_DOMAIN}`;

export const ORIGIN_DOMAIN = 'agmsoft.com';

export const ORIGIN_SITE_URL = `https://${ORIGIN_DOMAIN}`;

export const SUPPORT_MAIL = `info@${ORIGIN_DOMAIN}`;

export const SUPPORT_LINK = `mailto:${SUPPORT_MAIL}`;

export const TELEGRAM_DOMAIN = `agm_soft`;

export const TELEGRAM_LINK = `tg://resolve?domain=${TELEGRAM_DOMAIN}`;

export const OAUTH2_REDIRECT_TO_KEY = 'oauth2RedirectTo';

export const originSiteMap = {
  PRICES_PAGE_URL: `${ORIGIN_SITE_URL}/price`,
  TERMS_URL: `${ORIGIN_SITE_URL}/terms`,
  PRIVACY_URL: `${ORIGIN_SITE_URL}/privacy`,
  AGREEMENT_URL: `${ORIGIN_SITE_URL}/agreement`,
  PAYMENT_URL: `${ORIGIN_SITE_URL}/payment`,
};

export const RESIDENT_COUNTRY_CODE = 'BY';

// INPUT LENGTHS

export const INPUT_FIRST_NAME_MAX_LENGTH = 40;
export const INPUT_LAST_NAME_MAX_LENGTH = 40;
export const INPUT_MIDDLE_NAME_MAX_LENGTH = 40;
export const INPUT_COMPANY_MAX_LENGTH = 255;
export const INPUT_POSITION_MAX_LENGTH = 255;
export const INPUT_STAFF_MAX_LENGTH = 9;
export const INPUT_EMAIL_MAX_LENGTH = 255;
export const INPUT_PHONE_MAX_LENGTH = 19;
export const INPUT_DOMAIN_MAX_LENGTH = 63;
export const INPUT_PRODUCT_NAME_MAX_LENGTH = 255;
export const INPUT_PASSWORD_MIN_LENGTH = 6;
export const INPUT_PASSWORD_MAX_LENGTH = 100;
export const INPUT_SECRET_CODE_MAX_LENGTH = 6;
export const INPUT_PARTNER_CODE_MAX_LENGTH = 4;
export const INPUT_PARTNER_CODE_MIN_LENGTH = 4;
export const INPUT_DISCOUNT_PERCENT_MAX_LENGTH = 3;
export const INPUT_PARTNER_PERCENT_MAX_LENGTH = 3;
export const INPUT_PROMOCODE_PASSWORD_MAX_LENGTH = 100;
export const INPUT_PRODUCT_DEFAULT_PARTNER_COMISSION_MAX_LENGTH = 2;

export const PARTNER_PROFILE_AVATAR_INPUT_FILE_MAX_SIZE = BYTES_IN_MB * 10;
export const PARTNER_PROFILE_AVATAR_CROPPED_FILE_MAX_SIZE = BYTES_IN_MB * 1;
export const PARTNER_PROFILE_AVATAR_INPUT_FILE_TYPES = [
  'image/jpeg',
  'image/png',
];
export const PARTNER_PROFILE_AVATAR_MIN_WIDTH = 500;
export const PARTNER_PROFILE_AVATAR_MIN_HEIGHT = 500;
